export const THEMES = {
  Mango:  { cream: '#FFF4D6', ink: '#161315', yellow: '#FFC93A', pink: '#FF4D8D', blue: '#2E5BFF', green: '#18B26B' },
  Mint:   { cream: '#E9FFE3', ink: '#0E2018', yellow: '#FFD447', pink: '#FF5DA2', blue: '#2E8FFF', green: '#13A85F' },
  Berry:  { cream: '#FFE6F1', ink: '#1A0E1E', yellow: '#FFD447', pink: '#FF2E7A', blue: '#6C3BFF', green: '#18B26B' },
  Cobalt: { cream: '#E2ECFF', ink: '#0B1430', yellow: '#FFCE3A', pink: '#FF6BA6', blue: '#2E5BFF', green: '#16C083' },
};

export const THEME_NAMES = Object.keys(THEMES);
export const DEFAULT_THEME = 'Mango';
export const STORAGE_KEY = '4options.theme';

export const PLAYER_PALETTE = [
  { color: '#2E5BFF', emoji: '🦅' },
  { color: '#FF4D8D', emoji: '🐯' },
  { color: '#18B26B', emoji: '🦊' },
  { color: '#A05BFF', emoji: '🐙' },
  { color: '#FF8A4A', emoji: '🦁' },
  { color: '#16C083', emoji: '🐢' },
  { color: '#FFC93A', emoji: '🐝' },
  { color: '#FF6BA6', emoji: '🦋' },
];

export function playerStyleFor(index) {
  return PLAYER_PALETTE[index % PLAYER_PALETTE.length];
}
